// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2aNhd","row":"Node_row__kgY0g","label":"Node_label__25yU3","footer":"Node_footer__X3kuc"};